import type { ExternalContactPlatform } from '@minibook/shared';

/**
 * Фирменные цвета иконок — как в web-master `AppIcon` (`brandColors`).
 */
export const SOCIAL_BRAND_FG: Record<ExternalContactPlatform, string> = {
  vk: '#0077FF',
  telegram: '#27A7E7',
  whatsapp: '#25D366',
  viber: '#7360F2',
  max: '#0A84FF',
  instagram: '#E4405F',
  facebook: '#1877F2',
  tiktok: '#000000',
  youtube: '#FF0000',
  google_maps: '#34A853',
  yandex_maps: '#FC3F1D',
  two_gis: '#19C45B',
  avito: '#7C3AED',
};

/**
 * Светлые подложки под плитку — как `uiAccents.addButtons.*.bg` + mix 57%/56% с `--color-card` в мастере,
 * а не яркий бренд в color-mix (иначе «кислотная» плитка).
 */
export const SOCIAL_BRAND_TILE_BG: Record<ExternalContactPlatform, string> = {
  vk: '#E8F2FF',
  telegram: '#E3F5FC',
  whatsapp: '#E8FAF0',
  viber: '#EEEAFC',
  max: '#E5F1FF',
  instagram: '#FCE8ED',
  facebook: '#E7F1FE',
  tiktok: '#EFEFEF',
  youtube: '#FFE8E8',
  google_maps: '#E8F5EC',
  yandex_maps: '#FFEBEA',
  two_gis: '#E9F8EF',
  avito: '#F3EEFF',
};

const ICON_TEXT_MIX_PCT = 82;

/** Как `mixWithText` в web-master для цветных «+». */
export function socialBrandIconCssColor(platform: ExternalContactPlatform): string {
  const hex = SOCIAL_BRAND_FG[platform];
  return `color-mix(in srgb, ${hex} ${ICON_TEXT_MIX_PCT}%, var(--color-text-primary) ${100 - ICON_TEXT_MIX_PCT}%)`;
}
